import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector      : 'app-breadcrumb',
	templateUrl   : './breadcrumb.component.html',
	encapsulation : ViewEncapsulation.None
})

export class BreadcrumbComponent implements OnInit {
	@Input() breadCrumbData        : any;
	@Input() breadCrumbChildLength : number;

	constructor() {}

	ngOnInit() {}

	addMenuId( object_id ) {
		sessionStorage.setItem( 'currentPageID', JSON.stringify( object_id ) );
	}
}